import { Linking } from 'react-native'

export default {
  composeMessageWithArgs: (args, cb) => {
    Linking.openURL('sms:?body=' + encodeURIComponent(args.messageText))
  }
}
